import React from 'react';
import { Carousel } from '@arco-design/web-react';
import useLocale from '@/utils/useLocale';
import locale from './locale';
import styles from './style/index.module.less';

export default function LoginBanner() {
	const systemType =  localStorage.getItem("systemType");
	const t = useLocale(locale);
	const data = [
    // {
    //   slogan: t['login.banner.slogan1'],
    //   subSlogan: t['login.banner.subSlogan1'],
    //   image:
    //     'http://p1-arco.byteimg.com/tos-cn-i-uwbnlip3yd/6c85f43aed61e320ebec194e6a78d6d3.png~tplv-uwbnlip3yd-png.png',
    // },
    // {
    //   slogan: t['login.banner.slogan2'],
    //   subSlogan: t['login.banner.subSlogan2'],
    //   image:
    //     'http://p1-arco.byteimg.com/tos-cn-i-uwbnlip3yd/6c85f43aed61e320ebec194e6a78d6d3.png~tplv-uwbnlip3yd-png.png',
    // },
    // {
    //   slogan: t['login.banner.slogan3'],
    //   subSlogan: t['login.banner.subSlogan3'],
    //   image:
    //     'http://p1-arco.byteimg.com/tos-cn-i-uwbnlip3yd/6c85f43aed61e320ebec194e6a78d6d3.png~tplv-uwbnlip3yd-png.png',
    // },
  ];
  return (
    <Carousel className={styles.carousel} animation="fade">
    {/*
	{data.map((item, index) => (
	    <div key={`${index}`}>
	      <div className={styles['carousel-item']}>
	    
	        <img
	          alt="banner-image"
	          className={styles['carousel-image']}
	          src={item.image}
	        />
	      </div>
	    </div>
	  ))}
	*/} 
	  
	  <div >
		{systemType == '1' &&(
			<div className={styles['carousel-item']}>
			
			  <img
			    alt="banner-image"
			    className={styles['carousel-image']}
			    src={'https://haitzhitou.oss-cn-shanghai.aliyuncs.com/feed/screen/c2e372e17b2a87c8ab4a002e023ff49.png'}
			  />
			</div>
		)}
	    {systemType == '2' &&(
	    	<div className={styles['carousel-item']}>
	    	
	    	  <img
	    	    alt="banner-image"
	    	    className={styles['carousel-image']}
	    	    src={'https://haitzhitou.oss-cn-shanghai.aliyuncs.com/feed/screen/37480d367476519c910c1cd36a1c1a1.png'}
	    	  />
	    	</div>
	    )}
	  </div>
	  
    </Carousel>
  );
}
